interface AiAgentKeyDiffsWorkflowProps {
  selectedPolicyCount: number
  selectedPolicyCodes: string[]
  onGenerateReport: () => void
  onSelectPolicies: () => void
  isLoading: boolean
}

function AiAgentKeyDiffsWorkflow({
  selectedPolicyCount,
  selectedPolicyCodes,
  onGenerateReport,
  onSelectPolicies,
  isLoading,
}: AiAgentKeyDiffsWorkflowProps) {
  const isReady = selectedPolicyCount === 2
  const hasTooMany = selectedPolicyCount > 2
  const isEmpty = selectedPolicyCount === 0

  function handleCtaClick() {
    if (isReady) onGenerateReport()
    else onSelectPolicies()
  }

  return (
    <div className='ai-agent-keydiffs'>
      <div
        className={`ai-agent-keydiffs-card${isEmpty ? ' ai-agent-keydiffs-card--empty' : ''}`}
      >
        <h3 className='ai-agent-keydiffs-title'>Key Differences Report</h3>
        <p className='ai-agent-keydiffs-desc'>
          Get a side-by-side analysis of coverage, limits and exclusions between two policies.
        </p>

        <div className='ai-agent-keydiffs-status'>
          {isReady && (
            <span className='ai-agent-keydiffs-badge ready'>
              {selectedPolicyCodes[0]} vs {selectedPolicyCodes[1]}
            </span>
          )}
          {!isReady && !hasTooMany && (
            <span
              className={`ai-agent-keydiffs-badge pending${
                isEmpty ? ' ai-agent-keydiffs-badge--pending-empty' : ''
              }`}
            >
              {isEmpty ? 'No policies selected yet' : `${selectedPolicyCount}/2 policies selected`}
            </span>
          )}
          {hasTooMany && (
            <span className='ai-agent-keydiffs-badge warn'>
              {selectedPolicyCount} selected — keep exactly 2
            </span>
          )}
        </div>

        {isEmpty && (
          <p className='ai-agent-keydiffs-hint'>
            Pick two wordings from the comparison, then tap below to run the report.
          </p>
        )}

        <button
          className={`ai-agent-keydiffs-cta${isReady ? ' ready' : ''}`}
          onClick={handleCtaClick}
          disabled={isLoading}
        >
          {isLoading
            ? 'Generating…'
            : isReady
              ? 'Generate Report'
              : hasTooMany
                ? 'Adjust Selection'
                : 'Select Policies'}
        </button>
      </div>

      <div className='ai-agent-keydiffs-divider'>
        <span>or ask AL anything</span>
      </div>
    </div>
  )
}

export { AiAgentKeyDiffsWorkflow }
